import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111')
];

export const server_loads = [];

export const dictionary = {
		"/": [26],
		"/about-us": [72],
		"/affiliate": [73],
		"/aml-policy": [74],
		"/betfeed": [75],
		"/blog": [76],
		"/bonus-terms": [77],
		"/calendar": [78],
		"/casino": [79],
		"/complaints-and-arbitration": [80],
		"/fairness": [81],
		"/game/[game]": [82,[17]],
		"/in": [83],
		"/in/[actionSlug]": [84],
		"/kyc-policy": [85],
		"/leaderboard": [86],
		"/originals": [87],
		"/originals/[game]": [88,[18]],
		"/payment-policy": [91],
		"/privacy-policy": [92],
		"/promotion-page": [93],
		"/promotion-page/race/[...id]": [95,[22]],
		"/promotion-page/[...id]": [94,[21]],
		"/providers": [96],
		"/p/[provider]": [89,[19]],
		"/p/[provider]/[game]": [90,[19,20]],
		"/races/current": [98],
		"/races/last": [99],
		"/races/next": [100],
		"/races/[raceId]": [97],
		"/referral": [101],
		"/responsible-gaming": [102],
		"/special-bets": [104],
		"/special": [103,[23]],
		"/sports": [105,[24]],
		"/sports/[...slug]": [106,[24,25]],
		"/terms-of-service": [107],
		"/terms-sports": [108],
		"/tournaments": [109],
		"/transparency": [110],
		"/vip": [111],
		"/[provider=provider]": [70,[15]],
		"/[lang=lang]": [29,[3]],
		"/[category=category]": [28,[2]],
		"/[lang=lang]/about-us": [34,[3]],
		"/[lang=lang]/affiliate": [35,[3]],
		"/[lang=lang]/aml-policy": [36,[3]],
		"/[lang=lang]/betfeed": [37,[3]],
		"/[lang=lang]/blog": [38,[3]],
		"/[lang=lang]/bonus-terms": [39,[3]],
		"/[lang=lang]/calendar": [40,[3]],
		"/[lang=lang]/casino": [41,[3]],
		"/[lang=lang]/complaints-and-arbitration": [42,[3]],
		"/[lang=lang]/fairness": [43,[3]],
		"/[lang=lang]/game/[game]": [44,[3,7]],
		"/[lang=lang]/kyc-policy": [45,[3]],
		"/[lang=lang]/leaderboard": [46,[3]],
		"/[lang=lang]/originals": [47,[3]],
		"/[lang=lang]/originals/[game]": [48,[3,8]],
		"/[lang=lang]/payment-policy": [51,[3]],
		"/[lang=lang]/privacy-policy": [52,[3]],
		"/[lang=lang]/promotion-page": [53,[3]],
		"/[lang=lang]/promotion-page/race/[...id]": [55,[3,12]],
		"/[lang=lang]/promotion-page/[...id]": [54,[3,11]],
		"/[lang=lang]/providers": [56,[3]],
		"/[lang=lang]/p/[provider]": [49,[3,9]],
		"/[lang=lang]/p/[provider]/[game]": [50,[3,9,10]],
		"/[lang=lang]/races/current": [58,[3]],
		"/[lang=lang]/races/last": [59,[3]],
		"/[lang=lang]/races/next": [60,[3]],
		"/[lang=lang]/races/[raceId]": [57,[3]],
		"/[lang=lang]/referral": [61,[3]],
		"/[lang=lang]/responsible-gaming": [62,[3]],
		"/[lang=lang]/special-bets": [64,[3]],
		"/[lang=lang]/special": [63,[3,13]],
		"/[lang=lang]/sports": [65,[3]],
		"/[lang=lang]/sports/[...slug]": [66,[3,14]],
		"/[lang=lang]/terms-of-service": [67,[3]],
		"/[lang=lang]/tournaments": [68,[3]],
		"/[lang=lang]/vip": [69,[3]],
		"/[lang=lang]/[provider=provider]": [32,[3,5]],
		"/[lang=lang]/[category=category]": [31,[3,4]],
		"/[lang=lang]/[provider=provider]/[game]": [33,[3,5,6]],
		"/[provider=provider]/[game]": [71,[15,16]],
		"/[lang=lang]/[...fallback]": [30,[3]],
		"/[...fallback]": [27]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';